<template>
    <div v-if="loaded">
        <div class="fuel-gauge hidden-mobile" v-if="isAdmin" :class="{ danger: percentage < 30 , warning: percentage < 50 && percentage > 29 }">
          <heading colour="white" size="medium" no-margin>{{ amount }} Left In The Tank</heading>
            <p v-if="percentage < 30">The fuel tank is only {{ percentage }}% full. Refill soon.</p>
            <p v-if="percentage < 50 && percentage > 29">The fuel tank is {{ percentage }}% full.</p>
            <p v-if="percentage > 49">The fuel tank is {{ percentage }}% full. Safe for now.</p>

            <ui-button colour="white" class="mt-4" :href="url">Add / Remove Fuel</ui-button>
        </div>
        <div v-else class="fuel-gauge hidden-mobile">
          <heading colour="white" size="medium" no-margin>Add Fuel To Your Equipment / Vehicle</heading>
            <p>Click the link to log the fuel you are adding to your equipment or vehicle.</p>
            <ui-button colour="white" class="mt-4" :href="url">Add / Remove Fuel</ui-button>
        </div>
        <div class="hidden-desktop dashboard-component-icon" :class="{ danger: percentage < 30 , warning: percentage < 50 && percentage > 29 }">
          <heading colour="white" size="medium">Fuel</heading>
            <a :href="url"><i class="fa fa-tachometer"></i></a>
        </div>
    </div>
</template>

<script>
    export default {
        components: {},
        props:['amount','percentage','url','canManage'],
        data() {
            return {
                loaded:true
            };
        },
        computed: {
            isAdmin(){
                return this.canManage == 'true';
            }
        },
        watch: {},
        methods: {},
        mounted() {
            var that = this;
        }
    }
</script>

<style lang="scss" scoped>
    .dashboard-component-icon{
        background-color: $green;
        &.warning{
            background-color:#ED7003;
        }
        &.danger{
            background-color:$red;
        }
    }
    .fuel-gauge {
        @include clearfix();
        background-color: $green;
        border-radius: $standardBorderRadius;
        padding: 1em;
        font-size: 1em;
        color: #FFF;
        position: relative;

        h1{
            color:#FFF;
        }

        .warning{
            background-color:#ED7003;
            a{
                color:#ED7003;
                &:hover{
                    background-color: #ffece3;
                }
            }
        }
        .danger{
            background-color:$red;
            a{
                color:$red;
                &:hover{
                    background-color: #ffeaed;
                }
            }
        }
    }

</style>
